module.exports = __webpack_public_path__ + "img/loading copy.27b9019a.svg";